import { DateTime } from "luxon";

import { Cart } from "../models/Cart";

export interface CartUpsellConfig {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    shouldShow: (cart: Cart | null, boxofficeMode: boolean) => boolean;
    getDepartmentId?: (cart: Cart | null) => number | null;
    quantity?: number;
    // When set, the dialog navigates to this URL instead of adding to cart.
    href?: string;
    onAdd?: () => void;
}

// export const TASTE_SAMPLES_UPSELL: CartUpsellConfig = {
//     title: "Add 30 Taste Samples?",
//     message: "Buy early and avoid the lineups!",
//     confirmText: "Add to Cart",
//     cancelText: "No Thanks",
//     shouldShow: (cart, boxofficeMode) => {
//         if (!cart) return false;
//         if (boxofficeMode) return false;

//         const hasEvent1395 = cart.items.some((i) => i.event.id === 1395);
//         const hasEvent1390 = cart.items.some((i) => i.event.id === 1390);
//         const hasSamples = cart.items.some(
//             (i) => i.department.id === 33147 || i.department.id === 33172,
//         );

//         return !hasSamples && (hasEvent1395 || hasEvent1390);
//     },
//     getDepartmentId: (cart) => {
//         if (!cart) return null;

//         const hasEvent1395 = cart.items.some((i) => i.event.id === 1395);
//         const hasEvent1390 = cart.items.some((i) => i.event.id === 1390);

//         if (hasEvent1395) return 33172;
//         if (hasEvent1390) return 33147;

//         return null;
//     },
//     quantity: 1,
// };

const VIP_QUALIFYING_EVENT_ID = 1448;
const FRONT_ROW_VIP_EVENT_ID = 1470;

export const FRONT_ROW_VIP_UPSELL: CartUpsellConfig = {
    title: "Level up your night",
    message:
        "Get the Front Row VIP Experience at the Bell SOUNDSTAGE at the Bandshell. Limited Add-Ons available while quantities last.",
    confirmText: "View VIP Tickets",
    cancelText: "No Thanks",
    href: "/store/cne/1470",
    shouldShow: (cart, boxofficeMode) => {
        if (!cart) return false;
        if (boxofficeMode) return false;

        const hasQualifying = cart.items.some(
            (i) => i.event.id === VIP_QUALIFYING_EVENT_ID,
        );
        const hasVip = cart.items.some(
            (i) => i.event.id === FRONT_ROW_VIP_EVENT_ID,
        );

        return hasQualifying && !hasVip;
    },
};

export const WHISKY_CIGAR_UPSELL: CartUpsellConfig = {
    title: "Complete the experience",
    message: "Would you like to add the Whisky & Cigar Add-On to your order?",
    confirmText: "Add to Cart",
    cancelText: "No Thanks",
    shouldShow: (cart, boxofficeMode) => {
        if (!cart) return false;
        if (boxofficeMode) return false;

        const hasQualifyingTicket = cart.items.some((i) =>
            [33839, 33840].includes(i.department.id),
        );
        const hasAddOn = cart.items.some((i) => i.department.id === 33849);

        return hasQualifyingTicket && !hasAddOn;
    },
    getDepartmentId: (cart) => {
        if (!cart) return null;
        const hasQualifyingTicket = cart.items.some((i) =>
            [33839, 33840].includes(i.department.id),
        );
        return hasQualifyingTicket ? 33849 : null;
    },
    quantity: 1,
};

// Front of the Line midway add-on. The department switches over on
// Sept 11 @ 1:00am (Toronto time).
const FOTL_QUALIFYING_DEPARTMENT_IDS = [34229, 34233];
const FOTL_DEPARTMENT_ID_BEFORE = 34230;
const FOTL_DEPARTMENT_ID_AFTER = 34234;
const FOTL_SWITCHOVER = DateTime.fromObject(
    { year: 2026, month: 9, day: 11, hour: 1 },
    { zone: "America/Toronto" },
);

function getFrontOfTheLineDepartmentId(): number {
    return DateTime.now().setZone("America/Toronto") < FOTL_SWITCHOVER
        ? FOTL_DEPARTMENT_ID_BEFORE
        : FOTL_DEPARTMENT_ID_AFTER;
}

export const FRONT_OF_THE_LINE_UPSELL: CartUpsellConfig = {
    title: "Skip the wait on the midway",
    message:
        "Add a Front of the Line Pass and use the express lane to get on rides faster.",
    confirmText: "Add to Cart",
    cancelText: "No Thanks",
    shouldShow: (cart, boxofficeMode) => {
        if (!cart) return false;
        if (boxofficeMode) return false;

        const hasQualifyingTicket = cart.items.some((i) =>
            FOTL_QUALIFYING_DEPARTMENT_IDS.includes(i.department.id),
        );
        const hasAddOn = cart.items.some((i) =>
            [FOTL_DEPARTMENT_ID_BEFORE, FOTL_DEPARTMENT_ID_AFTER].includes(
                i.department.id,
            ),
        );

        return hasQualifyingTicket && !hasAddOn;
    },
    getDepartmentId: (cart) => {
        if (!cart) return null;
        const hasQualifyingTicket = cart.items.some((i) =>
            FOTL_QUALIFYING_DEPARTMENT_IDS.includes(i.department.id),
        );
        return hasQualifyingTicket ? getFrontOfTheLineDepartmentId() : null;
    },
    quantity: 1,
};
